
import { Component, Model, Vue } from 'vue-property-decorator';
import { ViewType } from '@/components/prine/enums/ViewType';

@Component({
    name: 'ProjectViewTypeSelector',
    components: {},
})
export default class ProjectViewTypeSelector extends Vue {
    @Model('change', {
        required: true,
    })
    private viewState: ViewType;

    private ViewType = ViewType;

    get state() {
        return this.viewState;
    }

    set state(state) {
        this.$emit('change', state);
    }
}
